export * from './delete-zeit.service';
export * from './delete-zeit.service.module';